import css_5qdrg9q1p69 from './css/Spinner.css';
import Div from './Div.js';
import Span from './Span.js';

const css = css_5qdrg9q1p69;

export default class Spinner extends Div
{
	get cssText()
	{
		return css;
	}
}

export class Spinner2 extends Div
{
	constructor(parentDiv)
	{
		super(parentDiv);

		new Mask(this).element.classList.add('top');
		new Mask(this).element.classList.add('middle');
		new Mask(this).element.classList.add('bottom');

		new Span(this).value = 'LOADING...';
	}
	get cssText()
	{
		return css;
	}
}

class Mask extends Div {}